<template>
  <div>
    <form id="indicarForm" @submit.prevent="submit" class="ajax_off">
      <ClienteSelect v-model="indicacao.cliente_id" modal />

      <div class="messagem_indicacao" style="text-align: center" v-if="success">
        <p>
          A <b>Aresta Group</b> agradece a sua indicação, em breve entraremos em
          contato com o seu cliente.
        </p>
      </div>
      <div class="form-group div_form" v-if="indicacao.cliente_id">
        <div class="form-group">
          <label>Tipo de Serviço</label>
          <e-select
            v-model="indicacao.servico_id"
            route="tiposServicosSelect"
            name="servico_id"
          />
        </div>

        <div
          class="form-group col-md-12 tipos-de-certificados"
          v-if="indicacao.servico_id == 7"
        >
          <label>Selecione o certificado</label>

          <e-select
            route="certificadosPrecoSelect"
            v-model="indicacao.certificado_digital_preco_id"
            name="certificado_digital_preco_id"
          />
        </div>

        <div
          class="form-group outro_servico col-md-12"
          v-if="indicacao.servico_id == 8"
        >
          <input
            type="text"
            v-model="indicacao.indicacao_outro_servico"
            name="outro_servico"
            class="form-control outro_servico_input"
            placeholder="Escreva aqui o tipo de serviço."
            required
          />
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label>Telefone do indicado</label>
            <the-mask
              type="tel"
              :mask="['(##)####-####', '(##)#####-####']"
              v-model="indicacao.indicacao_telefone"
              name="indicacao_telefone"
              class="form-control tel telefone_1"
              maxlength="14"
              required=""
            />
          </div>
          <div class="form-group col-md-6">
            <label>Celular do indicado</label>
            <the-mask
              type="tel"
              :mask="['(##)#####-####']"
              maxlength="14"
              v-model="indicacao.indicacao_celular"
              name="indicacao_celular"
              class="form-control cel"
            />
          </div>
        </div>

        <div class="form-group">
          <label>Pessoa para contato</label>
          <input
            type="text"
            v-model="indicacao.indicacao_nome"
            name="indicacao_nome"
            class="form-control"
            placeholder="Pessoa para contato"
            required=""
          />
        </div>

        <div class="form-group" v-if="parceiro && parceiro.is_ar">
          <label>Consultor</label>

          <e-select
            v-model="indicacao.consultor_id"
            route="consultoresSelect"
            name="consultor_id"
          />
        </div>

        <div class="form-group" v-if="ativar_upload">
          <label
            >Para dar celeridade ao atendimento, favor anexar o(s) documento(s)
            abaixo (OPCIONAL):</label
          >
          <b-form-group label="Alvará corpo de bombeiro:" label-cols-sm="3">
            <b-form-file
              v-model="files[0]"
              placeholder="clique ou arraste para anexar..."
              drop-placeholder="Arraste aqui..."
            ></b-form-file>
          </b-form-group>
          <b-form-group label="Carnê IPTU:" label-cols-sm="3">
            <b-form-file
              v-model="files[1]"
              placeholder="clique ou arraste para anexar..."
              drop-placeholder="Arraste aqui..."
            ></b-form-file>
          </b-form-group>
        </div>

        <div class="form-group" v-if="indicacao.anexos.length > 0">
          <ul class="list-group">
            <li
              class="
                list-group-item
                d-flex
                justify-content-between
                align-items-center
              "
              v-for="(anexo, index_anexo) in indicacao.anexos"
              :key="index_anexo"
            >
              <span>{{ anexo.arquivo_name }}</span>
              <b-button
                size="sm"
                variant="outline-secondary"
                v-b-tooltip.hover.left
                title="Remover anexo"
                type="button"
                @click.prevent="removerAnexo(index_anexo)"
                ><i class="fas fa-backspace"></i
              ></b-button>
            </li>
          </ul>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ClienteSelect from "../../sistema/ClientesSelect.vue";

import { mapState, mapActions } from "vuex";
export default {
  components: { ClienteSelect },
  data() {
    return {
      servicos: [],
      cliente: {},
      files: [],
      consultores: [],
      success: false,
      indicacao: {
        anexos: [],
      },
      ativar_upload: false,
      label_upload: "",
    };
  },
  computed: {
    ...mapState("user", ["user", "parceiro"]),
  },
  watch: {
    "indicacao.cliente_id": function (newValue) {
      if (newValue) this.getCliente();
    },
    "indicacao.servico_id": function (newValue) {
      this.getServico();
    },
  },

  created() {
    if (this.user && this.user.user_function == 3) {
      this.indicacao.consultor_id = this.user.user_id;
    }
  },
  methods: {
    ...mapActions("user", ["getUser"]),
    async submit() {
      const formData = new FormData();

      for (
        var i = 0;
        i < this.files.filter((item) => item && item.name).length;
        i++
      ) {
        let file = this.files.filter((item) => item && item.name)[i];
        formData.append(`files[${i}]`, file);
      }
      formData.append("indicacao", JSON.stringify(this.indicacao));

      const headers = { "Content-Type": "multipart/form-data" };

      await this.$api.post("indicacao", formData, headers);
      this.success = true;
      this.getUser();
      this.$bvModal.hide("indicar");
      this.$router.push("/indicacoes");
    },
    async getCliente() {
      const result = await this.$api.get(
        `cliente/${this.indicacao.cliente_id}`
      );
      this.cliente = result.data;
      this.indicacao.indicacao_telefone = result.data.telefone_1;
      this.indicacao.indicacao_celular = result.data.telefone_2;
    },
    async getServico() {
      const result = await this.$api.get(
        `tipo-de-servico/${this.indicacao.servico_id}`
      );

      this.ativar_upload = Boolean(Number(result.data.ativar_upload));
      this.label_upload = result.data.label_upload || "Anexar arquivos";
    },

    arquivoSelecionado(arquivo) {
      this.indicacao.anexos.push(arquivo);
    },

    removerAnexo(index) {
      this.indicacao.anexos.splice(index, 1);
    },
  },
};
</script>
